webpackJsonp([35783957827783],{

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-icon.2679d524.png";

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = HomePage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Page = __webpack_require__(52);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Footer = __webpack_require__(405);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Wrap = __webpack_require__(33);
	
	var _Wrap2 = _interopRequireDefault(_Wrap);
	
	var _LinkButton = __webpack_require__(242);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _GitHubButton = __webpack_require__(241);
	
	var _GitHubButton2 = _interopRequireDefault(_GitHubButton);
	
	var _CodeBlock = __webpack_require__(21);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var _indexModule = __webpack_require__(559);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _modifiersStyles = __webpack_require__(239);
	
	var _modifiersStyles2 = _interopRequireDefault(_modifiersStyles);
	
	var _input = __webpack_require__(237);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _inputFromTo = __webpack_require__(236);
	
	var _inputFromTo2 = _interopRequireDefault(_inputFromTo);
	
	var _localization = __webpack_require__(238);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _selectedRange = __webpack_require__(240);
	
	var _selectedRange2 = _interopRequireDefault(_selectedRange);
	
	var _logoIcon = __webpack_require__(851);
	
	var _logoIcon2 = _interopRequireDefault(_logoIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HomePage() {
	  return _react2.default.createElement(
	    _Page2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _indexModule2.default.hero },
	      _react2.default.createElement(
	        _Wrap2.default,
	        null,
	        _react2.default.createElement('img', {
	          alt: 'react-day-picker Logo',
	          src: _logoIcon2.default,
	          width: 100,
	          height: 110
	        }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'react-day-picker'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Date picker component for',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://facebook.github.io/react/' },
	            'React'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Flexible, highly customizable, localizable, with ARIA support, no external dependencies,',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              href: 'https://bundlephobia.com/result?p=react-day-picker'
	            },
	            '7.4kB gzipped'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _LinkButton2.default,
	            { to: '/docs' },
	            'Read the docs'
	          ),
	          _react2.default.createElement(
	            _LinkButton2.default,
	            { to: '/examples' },
	            'Browse the examples'
	          )
	        ),
	        _react2.default.createElement(_GitHubButton2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Wrap2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _indexModule2.default.features },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Style days with modifiers'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Define the disabled or selected days and change the aspect of each day cell with ',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/docs/matching-days' },
	              'modifiers'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _indexModule2.default.feature },
	            _react2.default.createElement(_modifiersStyles2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Works with input fields'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Display the date picker in an overlay using the',
	            ' ',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/docs/input' },
	              'DayPickerInput'
	            ),
	            ' component.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _indexModule2.default.feature },
	            _react2.default.createElement(_input2.default, null),
	            _react2.default.createElement(
	              'p',
	              null,
	              '...or choose a range of days:'
	            ),
	            _react2.default.createElement(_inputFromTo2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Localizable'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Use your own translation strings or import those from moment.js, if you use it.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _indexModule2.default.feature },
	            _react2.default.createElement(_localization2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Select range of days'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Specify which days should be selected in your component\u2019s state (',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/examples/selected-range' },
	              'source'
	            ),
	            ').'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _indexModule2.default.feature },
	            _react2.default.createElement(_selectedRange2.default, { numberOfMonths: 1 })
	          )
	        )
	      ),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Get started'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _indexModule2.default.gettingStarted },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Install via npm or yarn'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { span: 2 },
	          _react2.default.createElement(
	            _CodeBlock2.default,
	            { language: 'bash' },
	            '$ npm install react-day-picker --save\n# or with yarn:\n$ yarn add react-day-picker'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.npmjs.com/package/react-day-picker' },
	              _react2.default.createElement('img', {
	                src: 'https://img.shields.io/npm/v/react-day-picker.svg?style=flat-square',
	                alt: 'npm version'
	              })
	            ),
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://npm-stat.com/charts.html?package=react-day-picker' },
	              _react2.default.createElement('img', {
	                src: 'https://img.shields.io/npm/dm/react-day-picker.svg?style=flat-square',
	                alt: 'npm downloads'
	              })
	            ),
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://circleci.com/gh/gpbl/react-day-picker' },
	              _react2.default.createElement('img', {
	                src: 'https://img.shields.io/circleci/project/github/gpbl/react-day-picker/master.svg?style=flat-square',
	                alt: 'circleci'
	              })
	            ),
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://codecov.io/gh/gpbl/react-day-picker' },
	              _react2.default.createElement('img', {
	                src: 'https://img.shields.io/codecov/c/github/gpbl/react-day-picker/master.svg?style=flat-square',
	                alt: 'npm downloads'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Import in your component'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { span: 2 },
	          _react2.default.createElement(
	            _CodeBlock2.default,
	            null,
	            'import React from \'react\';\nimport DayPicker from \'react-day-picker\';\nimport \'react-day-picker/lib/style.css\';\n\nexport default function Hello() {\n  return <DayPicker />;\n}\n'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hero":"src-pages----index-module---hero---nkUhx","features":"src-pages----index-module---features---1Pthj","feature":"src-pages----index-module---feature---2x5dX","featureExample":"src-pages----index-module---featureExample---2wkS7","gettingStarted":"src-pages----index-module---gettingStarted---34DAa"};

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Footer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__(304);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _GitHubButton = __webpack_require__(241);
	
	var _GitHubButton2 = _interopRequireDefault(_GitHubButton);
	
	var _Wrap = __webpack_require__(33);
	
	var _Wrap2 = _interopRequireDefault(_Wrap);
	
	var _FooterModule = __webpack_require__(562);
	
	var _FooterModule2 = _interopRequireDefault(_FooterModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: _FooterModule2.default.footer },
	    _react2.default.createElement(
	      _Wrap2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _FooterModule2.default.container },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '/' },
	            _react2.default.createElement('img', { src: _logo2.default, alt: 'Home page', height: 30 })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_GitHubButton2.default, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Created by ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/gpbl' },
	              'gpbl'
	            ),
	            ' and',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/gpbl/react-day-picker/graphs/contributors' },
	              'contributors'
	            ),
	            '. Licensed under the',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/gpbl/react-day-picker/blob/master/LICENSE' },
	              'MIT License'
	            ),
	            '.'
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"src-ui----Footer-module---footer---18LyG","container":"src-ui----Footer-module---container---23Z0x"};

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = GitHubButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GitHubButton() {
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('script', { async: true, defer: true, src: 'https://buttons.github.io/buttons.js' })
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        className: 'github-button',
	        href: 'https://github.com/gpbl/react-day-picker',
	        'data-icon': 'octicon-star',
	        'data-show-count': 'true',
	        'aria-label': 'Star gpbl/react-day-picker on GitHub'
	      },
	      'Star'
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-05ff856e669131170814.js